/**
 * Return whether the element has <= options.distanceFromBottom left to scroll
 * (i.e. whether the element can be scrolled any further)
 *
 * @param {HTMLElement} element The HTML element which is being scrolled
 * @param {object} [options = { distanceFromBottom: 1 }] Options for the function
 * @param {number} [options.distanceFromBottom = 1] The distance from the bottom of the element
 * @returns
 */
export default function isScrolledToBottom(element, {
  distanceFromBottom = 1
} = {}) {
  const visibleHeight = element.clientHeight;
  const remainingScrollHeight = element.scrollHeight - element.scrollTop;
  return remainingScrollHeight - visibleHeight <= distanceFromBottom;
}